import React, { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { getUser, login } from './authService';

const ProtectedRoute = ({ children }) => {
    const [status, setStatus] = useState('loading'); // 'loading' | 'ok' | 'restricted'
    const location = useLocation();

    useEffect(() => {
        const check = async () => {
            try {
                const user = await getUser();
                if (!user) return; // getUser() triggers login redirect if no session
                const raw = user.profile['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ?? [];
                const roles = Array.isArray(raw) ? raw : [raw];
                setStatus(roles.includes('superuser') ? 'ok' : 'restricted');
            } catch {
                await login('/');
            }
        };
        check();
    }, [location.pathname]);

    if (status === 'loading') return <div />;
    if (status === 'restricted') return <Navigate to="/restricted" replace />;
    return children;
};

export default ProtectedRoute;
